//#region react import
import { useSelector } from "react-redux";
//#endregion

//#region components import
import SwitchWithText from "../../../Components/SwitchWithText/SwitchWithText.component";
//#endregion

//#region functions import
import { getTranslations } from "../../../Helper/TranslationController";
//#endregion

//#region constants import
import { NO, YES } from "../../../Components/GstaModal/GstaModal.constants";
//#endregion

//#region style import
import "../CenterParameters/CenterParameters.style.scss";
import "./SettingSwitch.style.scss";
//#endregion

const SettingSwitch = ({ setting, updateSettingValue, title, label, titleIcon }) => {
  //#region hook
  const translations = useSelector((state) => state.translationSlice.translations);
  const settingDictionary = useSelector((state) => state.settingSlice.settingDictionary);
  //#endregion

  return (
    <section className="setting-switch">
      <header>
        <h1>
          {titleIcon && <i className={titleIcon} />}
          <span>{getTranslations(title, translations)}</span>
        </h1>
      </header>
      <div>
        <SwitchWithText
          label={getTranslations(label, translations)}
          dataTestId={process.env.NODE_ENV === "test" && "switch-show-note"}
          onText={getTranslations(YES, translations)}
          offText={getTranslations(NO, translations)}
          checked={settingDictionary[setting] === "true"}
          handleChange={updateSettingValue}
        />
      </div>
    </section>
  );
};

export default SettingSwitch;
